import variables from '../styles/1__settings/_vars.module.scss'

export const mobileSize = parseInt(variables.breakpointSm, 10)
export const tabletSize = parseInt(variables.breakpointMd, 10)
export const smallDesktopSize = parseInt(variables.breakpointLg, 10)
export const desktopSize = parseInt(variables.breakpointXl, 10)
